import { css } from "@emotion/react";
import { Theme, useTheme } from "@mui/material";
import Link from "next/link";

import { fixedWidth } from "~/lib/client/design";
import { font } from "~/lib/client/fonts";
import { DatabaseDetailPageProps } from "~/pages/database/[id]";

/**
 * データベース詳細ページのカテゴリーとタイトルを表示するコンポーネント
 * 幅は 22rem で固定
 */
const CategoryAndTitle = ({
  form,
}: {
  form: DatabaseDetailPageProps["form"];
}) => {
  const theme = useTheme();
  return (
    <div css={rootStyle}>
      <div css={categoryContainerStyle(theme)}>
        {form.categories.map((category, index) => (
          <Link key={index} href={`/category/${category.id}`}>
            #{category.name}
          </Link>
        ))}
      </div>
      <div className={font.className} css={titleStyle(theme)}>
        <p>{form.title}</p>
      </div>
    </div>
  );
};

const rootStyle = css`
  ${fixedWidth("32rem")}

  display: flex;
  flex-direction: column;
  padding: 1.5rem;
  border-right: 1px solid #ccc;
`;

const categoryContainerStyle = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  color: ${theme.palette.primary.main};
`;

const titleStyle = (theme: Theme) => css`
  color: ${theme.palette.text.primary};
  font-size: 32px;
  font-weight: 600;
`;

export default CategoryAndTitle;
